import { encode, escape } from 'base64-url'

function assets_url (url, filters = null, afterUrl = '') {
  if (url == null)return null

  let f
  const base = "https://assets.sta.io"
  // const base = "http://192.168.56.101:7790"
  if (filters != null) {
    f = `/f:${filters}`
  } else {
    f = ''
  }

  if (url.startsWith('http')) {
    const b64url = escape(encode(url))
    let result_url = `${base}${f}/dl/:b64/${b64url}${afterUrl}?api_key=vjjlhfuw4PebucuhTey4`
    return result_url
  } else {
    return `${base}/site_media${f}/${url}`
  }
}

function format_date (x) {
  const d = new Date(x)
  return d.toLocaleDateString("de-AT", {weekday: "long", year: "numeric", month: "long", day: "numeric"})
}


function format_date_short (x) {
  const d = new Date(x)
  return d.toLocaleDateString("de-AT", {year: "numeric", month: "long", day: "numeric"})
}

function format_time (x) {
  const d = new Date(x)
  return d.toLocaleTimeString("de-AT", {hour: '2-digit', minute:'2-digit'})
}

export {
  assets_url,
  format_date,
  format_time,
  format_date_short,
}
